import React from 'react';
import { Section } from './ui';
export const Guarantee = () => {
  return <Section className="bg-white" data-id="element-78">
      <div className="max-w-3xl mx-auto bg-brand-cream border-4 border-dashed border-yellow-400 rounded-3xl p-6 md:p-12 text-center shadow-lg relative mt-10" data-id="element-79">
        <div className="absolute -top-9 left-1/2 transform -translate-x-1/2 bg-yellow-400 rounded-full w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-lg border-4 border-white" data-id="element-80">
          <span className="text-3xl md:text-4xl" data-id="element-81">🛡️</span>
        </div>

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold mt-4 md:mt-6 mb-5 text-brand-dark leading-tight" data-id="element-82">
          Garantía total de 7 días
        </h2>

        <div className="text-base sm:text-lg md:text-xl text-gray-700 space-y-3 mb-6" data-id="element-83">
          <p className="font-bold text-xl sm:text-2xl" data-id="element-84">Hornea un pastel.</p>
          <p data-id="element-85">
            Si no es el mejor pastel sin gluten que has probado, te devolvemos
            tu dinero.
          </p>
        </div>

        <div className="bg-white rounded-xl p-5 md:p-6 text-left inline-block mb-6 shadow-sm border border-gray-100 max-w-full" data-id="element-86">
          <ul className="space-y-3 md:space-y-4 text-base sm:text-lg font-medium" data-id="element-87">
            <li className="flex items-center gap-3" data-id="element-88">
              <span className="text-xl md:text-2xl shrink-0" data-id="element-89">↩️</span> Te
              devolvemos tus $9.990 ARS
            </li>
            <li className="flex items-center gap-3" data-id="element-90">
              <span className="text-xl md:text-2xl shrink-0" data-id="element-91">🎁</span> Te quedas
              con todo el material
            </li>
          </ul>
        </div>

        <p className="text-lg sm:text-xl font-bold text-brand-dark" data-id="element-92">
          Sin preguntas. Sin riesgo.
        </p>
      </div>
    </Section>;
};